  import { Box,Button,Flex,Select,InputGroup,
    InputLeftElement,Input, Heading, Text, 
    TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem, Image, UnorderedList, ListItem } from "@chakra-ui/react";
  import { DateFilter, TopDisplay,UploadButton } from "../../../components";
  import { BsDownload as DownloadIcon } from "react-icons/bs";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import { useState ,useEffect} from "react";
  import styled from "@emotion/styled";
  import { MdMoreVert as MoreIcon } from "react-icons/md";
  import apiCall from "../../../utils/apiCall";
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import ReactPaginate from 'react-paginate';
  import { TbReload as ReloadIcon } from "react-icons/tb";
  import { format } from "date-fns";
  import apiCallFormData from '../../../utils/apiFormDataCall';
  import { BsUpload as UploadIcon} from "react-icons/bs";
  import {
    Grid,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
    PopoverArrow,
  } from '@chakra-ui/react'
  import {useAtom,atom} from 'jotai'
  import { modalAtom, notificationAtom, openAtom, openNAtom } from "../../../context";
  import { Loader } from "../../../customs";
  import { useDropzone } from "react-dropzone";
  import { Field, Form, Formik } from "formik";
  import * as Yup from 'yup';
  import { FaRegFile as FileIcon,FaTimes as CancelIcon } from "react-icons/fa";
  const src=`/public-assets/upload_icon.png`;




  const indexAtom = atom<number | null>(null);
  const list = [
    {
      Id:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      Email:'Abey.Adesola@gmail.com',
      Subjects:"Subject1,Subject2",
      StudyCenter:"Yaba",
      LastExam:"HRM1,HRM2",
      RegistrationDate:"03-12-2023",
      Level:'2',
      Amount:'300,000',
      Results:'Pending'
    },
    {
      Id:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      Email:'Abey.Adesola@gmail.com',
      Subjects:"Subject1,Subject2",
      StudyCenter:"Yaba",
      LastExam:"HRM1,HRM2",
      RegistrationDate:"03-12-2023",
      Level:'2',
      Amount:'300,000',
      Results:'Pending'
    },
    {
      Id:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      Email:'Abey.Adesola@gmail.com',
      Subjects:"Subject1,Subject2",
      StudyCenter:"Yaba",
      LastExam:"HRM1,HRM2",
      RegistrationDate:"03-12-2023",
      Level:'2',
      Amount:'300,000',
      Results:'Pending'
    },
    {
      Id:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      Email:'Abey.Adesola@gmail.com',
      Subjects:"Subject1,Subject2",
      StudyCenter:"Yaba",
      LastExam:"HRM1,HRM2",
      RegistrationDate:"03-12-2023",
      Level:'2',
      Amount:'300,000',
      Results:'Pending'
    },
    {
      Id:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      Email:'Abey.Adesola@gmail.com',
      Subjects:"Subject1,Subject2",
      StudyCenter:"Yaba",
      LastExam:"HRM1,HRM2",
      RegistrationDate:"03-12-2023",
      Level:'2',
      Amount:'300,000',
      Results:'Pending'
    },
  ]

  const HeadStyle={
    borderBottom:"1px solid var(--dark-green-color)",
    padding:'15px 5px',
  }
  const DataStyle = {
    ":nth-of-type(5)":{
      maxWidth:'250px',
      overflow:'hidden'
    },
    padding:'5px 5px',
    thcolor:'var(--dark-green-color)'
  }


  const ROWSTYLE = styled.tr`
    & > td:last-of-type{
      width:50px;
      height:63px;
      & > div{
        display:none;
      }
    }
    &:hover > *{
      cursor: pointer;
      background-color:var(--table-highlight);
    } 
    & > td{
      width:140px;
    }
    &:hover > td:last-of-type{
      
      & > div{
        display: block;
      }
    }
    & > td > div.active{
      display: block;
    }
  `

  export default function MyApplication() {
    const [hide,set_hide] = useState<boolean>(true);
    const [activeIndex] = useAtom(indexAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);
    const queryClient = useQueryClient();
    const [selected_examperiod,set_selected_examperiod] = useState<any>(null);
    const [startDate, setStartDate] = useState<string | null>(null);
    const [endDate, setEndDate] = useState<string | null>(null);
    const [date_range,set_date_range] = useState<any>({startDate:'',endDate:''});

    const [search,set_search] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');

    const itemsPerPage = 100;
    const [pageNumber,set_pageNumber] = useState(1);

    useEffect(()=>{
      set_pageNumber(1);
    },[selected_examperiod?.Id, debouncedSearch])

    // Debounce so we don't fire a request on every keystroke.
    useEffect(()=>{
      const handler = setTimeout(()=>{
        setDebouncedSearch(search.trim());
      }, 400);
      return () => clearTimeout(handler);
    },[search])

    // Search is delegated to the server instead of pulling every page of the
    // dataset into memory client-side - that approach only got slower
    // (eventually feeling like it never finishes) as the dataset grew.
    // GetAllNotRegisteredStudent has no single "search everything" param -
    // it takes studentNo/firstName/lastName separately, so we route the one
    // free-text box into whichever field the input looks like it's meant for.
    const { data: pagedResult, isLoading } = useQuery(
      ["applications-page", selected_examperiod?.Id || "en", pageNumber, debouncedSearch],
      async () => {
        const fetchPage = async (extraParams: string) => {
          const response = await apiCall().get(
            `Exam/GetAllNotRegisteredStudent?PageNumber=${pageNumber}&PageSize=${itemsPerPage}${extraParams}`
          );
          return response.data;
        };

        const trimmed = debouncedSearch.trim();
        if (!trimmed) return fetchPage("");

        // Student numbers look like "CIPM/STD/A034720" - has a slash, or digits with no spaces.
        const looksLikeStudentNo = /\//.test(trimmed) || (/\d/.test(trimmed) && !/\s/.test(trimmed));
        if (looksLikeStudentNo) {
          return fetchPage(`&studentNo=${encodeURIComponent(trimmed)}`);
        }

        const words = trimmed.split(/\s+/).filter(Boolean);
        if (words.length > 1) {
          return fetchPage(
            `&firstName=${encodeURIComponent(words[0])}&lastName=${encodeURIComponent(words.slice(1).join(" "))}`
          );
        }

        // Single word and not a student number: could be a first or last name.
        // Try firstName first, fall back to lastName if nothing matched.
        const byFirstName = await fetchPage(`&firstName=${encodeURIComponent(trimmed)}`);
        if ((byFirstName?.TotalCount ?? byFirstName?.reportItems?.length ?? 0) > 0) {
          return byFirstName;
        }
        return fetchPage(`&lastName=${encodeURIComponent(trimmed)}`);
      },
      {
        keepPreviousData: true,
        select: (data: any) => ({
          items: data?.reportItems || [],
          pageCount: data?.PageCount || 1,
          totalCount: data?.TotalCount ?? (data?.reportItems || []).length,
        }),
      }
    );

    const filter_data = pagedResult?.items || [];
    const currentItems = filter_data;
    const pageCount = pagedResult?.pageCount || 1;
    const totalCount = pagedResult?.totalCount ?? filter_data.length;
    const displayOffset = (pageNumber - 1) * itemsPerPage;
    const displayEnd = Math.min(displayOffset + itemsPerPage, totalCount);

    const handlePageClick = (event:any) => {
      set_pageNumber(event.selected + 1);
    };

    const showUploadOldInductee = () =>{
      set_modal({
        header:'Upload Applicatios',
        content:<UploadOldInductee />
      })
      set_open(true);
    }
    const showDownloadTemplate = () =>{
      set_modal({
        header:'Downoad Excel Template ',
        content:<ViewDownloadTemplate />
      })
      set_open(true);
    }

    return (
      <>
        {isLoading?<Loader />:
          <Box>
          <TopDisplay label="Applications/Update Level In option" button_array={[
              <Button  bg="var(--dark-green-color)" color="var(--white-color)"  leftIcon={<UploadIcon/>}     variant="outline"
              colorScheme="var(--dark-green-color)"
              onClick={showUploadOldInductee}
            >Upload Applications</Button>,
            <Button variant="outline"  bg="var(--white-color)" color="var(--darek-green-color)"  leftIcon={<DownloadIcon/>}  
            colorScheme="var(--dark-green-color)"
            onClick={showDownloadTemplate}
          >Download Template</Button>,
            
          ]} />
            <Flex  gap="20px" wrap="wrap" mt="20px">
            <InputGroup width="300px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.300" />
            </InputLeftElement>
            <Input
              type="text"
              value={search}
              onChange={(e) => {
                set_search(e.target.value);
              }}
              placeholder="Search by Student No or Name"
              bg="var(--white-color)"
              borderColor="var(--dark-green-color)"
            />
            <span
              style={{
                position: "absolute",
                zIndex: "1",
                right: "10px",
                cursor: "pointer",
                top: "12px",
              }}
              onClick={() => {
                set_search("");
                setDebouncedSearch("");
                set_pageNumber(1);
              }}
            >
              <ReloadIcon />
            </span>
          </InputGroup>


              {/* <Select placeholder="Status" width="100px" bg="var(--white-color)" 
                borderColor="var(dark-green-color)">
              </Select> */}
              <DateFilter text="Date Range" onChange={set_date_range} />
            </Flex>
            <Flex mt="25px" flexDir="column" gap="10px">
              <Heading m="0" fontSize="1rem">All Applications</Heading>
              <Text m="0" fontSize=".8rem">showing {displayOffset} - {displayEnd} of {totalCount}</Text>
            </Flex>
        {  filter_data && filter_data.length > 0 ?<TableContainer mt="20px">
              <Table size='sm'>
                <Thead>
                  <Tr >
                    <Th sx={HeadStyle}>StudentNo</Th>
                    <Th sx={HeadStyle}>First-Name</Th>
                    <Th sx={HeadStyle}>Last-Name</Th>
                    <Th sx={HeadStyle}>phone</Th>
                    <Th sx={HeadStyle}>Email</Th>
                    <Th sx={HeadStyle}>Gender</Th>
                    {/* <Th sx={HeadStyle}>Study-Cent.</Th>
                    <Th sx={HeadStyle}>Last-Exam</Th> */}
                    <Th sx={HeadStyle}>Level</Th>
                    <Th sx={HeadStyle}>Address</Th>
                    <Th sx={HeadStyle}>Applied Date</Th>
                    <Th sx={HeadStyle} w="50px"></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.SN}>
                    <Td sx={DataStyle}>{eCandidate?.StudentNo || 'N/A'}</Td>
                    <Td sx={DataStyle}>{eCandidate?.FirstName || 'N/A'}</Td>
                    <Td sx={DataStyle}>{eCandidate?.LastName || 'N/A'}</Td>
                    <Td sx={DataStyle}>{eCandidate.PhoneNumber || 'N/A'}</Td>
                    <Td sx={DataStyle}>{eCandidate.Email || 'N/A'}</Td>
                    <Td sx={DataStyle}>{eCandidate.Gender || 'N/A'}</Td>
                    {/* <Td sx={DataStyle}>{eCandidate.StudyCenter}</Td>
                    <Td sx={DataStyle}>{eCandidate.LastExam}</Td> */}
                    <Td sx={DataStyle}>{eCandidate.Level?eCandidate.Level.ExemptionName:''}</Td>
                  <Td title={eCandidate?.Address} sx={{...DataStyle,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxW:'150px'}}>{eCandidate.Address ||'N/A'}</Td>
                    <Td sx={DataStyle}>{format(new Date(eCandidate.RegistrationDate), "dd/MM/yyyy")}</Td>
                    <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                        <div className={activeIndex === index?'active':''}><Option {...{index,candidate:eCandidate}}/></div>
                    </Td>
                  </ROWSTYLE>
                  )}
                </Tbody>
              </Table>
            </TableContainer>
            :'No Applicant found'  
          }
          <StylePaginateBox>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
          />

        </StylePaginateBox>

        </Box>
        }
      </>
      
    )
  }
  const StylePaginateBox = styled.div`
    width:100%;
    & > ul{
      list-style-type: none;
      text-align:center;
      padding:0;
      margin:0;
      margin-top:10px;
    } 
    & > ul > li{
      display: inline;
      margin:0 5px;
      padding:2px 5px;
      border-radius: 3px;
      background-color: transparent;
      color:var(--dark-green-color);
    }
    & > ul > li.selected{
      background-color: var(--highlight-paginate-background);
      color:var(--highlight-paginate-color);
    }
    & > ul > li:first-of-type,
    & > ul > li:last-of-type{
      font-weight: bold;
    }
  `

  const sx={
    ':hover':{
      bg:'var(--content-background)'
    }
  }

  const Option = (props:any)=>{
    const index = props.index;
    const candidate= props.candidate;
    const [ind,set_index] = useAtom(indexAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);
    const [,set_N_open] = useAtom(openNAtom);
    const [,set_notification] = useAtom(notificationAtom);
    const [new_level,set_new_level] = useState<any>(candidate?.Level?.Id);
    const queryClient = useQueryClient();
    
    const {data:allLevels} = useQuery(['exam-level'],{
      queryFn:async ()=> await apiCall().get(`/SetUp/GetAllExemption`),
      select(data){
        return data.data.Data;
      }
    })

    useEffect(()=>{
      set_new_level(candidate?.Level?.Id)
    },[])

    const onClick=()=>{
      if(index === ind){
        set_index(null);
        return;
      }
      set_index(index);
    }
    const handleShowProfile = () =>{
      set_index(null);
      set_modal({
        header:'Candidate Details',
        content:<ViewProfile candidate={candidate} />
      })
      set_open(true);
    }

    const { mutate: updateLevel, isLoading: isLoadingUpdate } = useMutation({
      mutationFn: async () => {
        if (!new_level) {
          throw new Error("Please select a new level before updating.");
        }
        return await apiCall().post('/Exam/changeExamLevel', {
          StudentMembershipNo: candidate.StudentNo,
          NewLevelId: new_level,
        });
      },
      onSuccess(data: any) {
        set_notification({
          type: 'success',
          message: data.data.Message || 'Level Updated Successfully',
        });
        set_N_open(true);
        queryClient.invalidateQueries({
          queryKey: ['not-registered-student'],
        });
      },
      onError(error: any) {
        set_notification({
          type: 'error',
          message: error?.response?.data?.Message || 'Error Occurred',
        });
        set_N_open(true);
      },
      onSettled: () => {
        set_open(false);
      },
    });
    


    const handleUpdateLevel = () => {
      set_modal({
        header: 'Update Exam Level',
        content: (
          <Flex flexDir="column" gap="20px">
            <Input
              placeholder="Name"
              value={`${candidate.FirstName} ${candidate.LastName}`}
              disabled
              onChange={() => {}}
              w="100%"
            />
            <Input
              placeholder="Level"
              value={`${candidate.Level.ExemptionName}`}
              disabled
              onChange={() => {}}
              w="100%"
            />
            <Select
              placeholder="Select New Level"
              w="100%"
              onChange={(e: any) => set_new_level(e.target.value)}
            >
              {allLevels.map((eLevel: any) => (
                <option key={eLevel.Id} value={eLevel.Id}>
                  {eLevel.Name}
                </option>
              ))}
            </Select>
            <Flex justify="center" w="100%">
              <Button
                onClick={() => {
                  if (!new_level) {
                    set_notification({
                      type: 'error',
                      message: 'Please select a new level before updating.',
                    });
                    set_N_open(true);
                  } else {
                    updateLevel();
                  }
                }}
                disabled={isLoadingUpdate}
                bg="var(--dark-green-color)"
                color="var(--white-color)"
              >
                {isLoadingUpdate ? 'Loading...' : 'Update'}
              </Button>
            </Flex>
          </Flex>
        ),
      });
      set_open(true);
    };
    
    useEffect(()=>{
      return ()=>set_index(null)
    },[])

    return(
      <Popover>
      <PopoverTrigger>
        <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
      </PopoverTrigger>
      <PopoverContent width="fit-content">
        <PopoverArrow />
        <PopoverBody>
          <Grid templateColumns="1fr" p="6px">
            <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
            <GridItem sx={sx} p="8px 4px" onClick={handleUpdateLevel}>Update Level</GridItem>
          </Grid>
        </PopoverBody>
      </PopoverContent>
    </Popover>
    )
  }

  const ViewProfile = (props: any) => {
    // Default image URL
    const defaultImage = "/public-assets/profile-not-found.png"; // Path to your default image
    const imageUrl = props.candidate?.ImageUrl || defaultImage; // Use default image if ImageUrl is not available

    return (
        <Flex flexDir="column" minWidth="600px" maxWidth="60dvw" gap="50px">
            <Flex align="center" gap="20px">
                <Image
                    src={imageUrl} // Use the imageUrl variable here
                    width="100px"
                    height="100px"
                    borderRadius="10%"
                    objectFit="cover"
                    objectPosition="center"
                    alt="No image found"
                    fallbackSrc={defaultImage} 
                />
                <Flex flexDir="column">
                    <Heading fontSize="1rem">{`${props.candidate.FirstName} ${props.candidate.LastName}`}</Heading>
                    <Text>Student</Text>
                    <Text>ID: {props.candidate.StudentNo}</Text>
                </Flex>
            </Flex>
            <Grid templateColumns="repeat(3, 1fr)" gap="30px">
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Present Level</Text>
                    <Text fontWeight="500">{props.candidate?.Level?.ExemptionName}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Amount Paid</Text>
                    <Text fontWeight="500"># {props.candidate.Amount}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Study Center</Text>
                    <Text fontWeight="500">{props.candidate.StudyCenter || 'Study Center 1'}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Application Date</Text>
                    <Text fontWeight="500">{format(new Date(props.candidate.RegistrationDate), "dd/MM/yyyy")}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Email Address</Text>
                    <Text fontWeight="500">{props.candidate.Email}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Gender</Text>
                    <Text fontWeight="500">{props.candidate.Gender}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Phone No.</Text>
                    <Text fontWeight="500">{props.candidate.PhoneNumber}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Address</Text>
                    <Text fontWeight="500">{props.candidate.Address}</Text>
                </GridItem>
            </Grid>
        </Flex>
    )}
    
    const UploadSchema = Yup.object({
      Applications:Yup.mixed()
    
    });
      
      
    const UploadOldInductee = (props:any) =>{
      // console.log({...props},'data')
      const queryClient = useQueryClient();
      const [,set_open] = useAtom(openAtom);
      const [,set_Nopen] = useAtom(openNAtom);
      const [,set_notification]= useAtom(notificationAtom);
      
      const [uploadedFiles, setUploadedFiles] = useState<any>([]);
      const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles) => {
        // console.log(acceptedFiles.join(','),'files');
          setUploadedFiles(acceptedFiles);
          // Call your backend API endpoint to upload files
        },
      });
    
      const removeFile=(name:any)=>{
        setUploadedFiles((files:any[]) => files?.filter(eFile => eFile.name != name));
      }
    
      const { mutate: addUpdate, isLoading } = useMutation({
        mutationKey: ['old-inductees'],
        mutationFn: async (data: FormData) => {
          return await apiCallFormData().post(`/ExamUpload/uploadOldInducteeApplication`, data);
        },
        onSuccess: (data) => {
          set_notification({
            type: 'success',
            message: data?.data?.Message || 'Uploaded Successfully',
          });
          set_Nopen(true);
          queryClient.invalidateQueries({
            queryKey: ['old-inductee'],
          });
          setUploadedFiles([]);
        },
        onError: (error: any) => {
          let errorMessage = 'An error occurred. Please try again.';
          
          if (error?.response?.data) {
            const errorData = error.response.data;
            
            // If API returns a structured validation error
            if (errorData.errors) {
              const validationErrors = Object.values(errorData.errors)
                .flat()
                .join(', ');
              errorMessage = validationErrors;
            } else {
              // Generic API error message
              errorMessage = errorData?.Message || errorData?.title || errorMessage;
            }
          }
      
          set_notification({
            type: 'error',
            message: errorMessage,
          });
          set_Nopen(true);
        },
        onSettled: () => {
          set_open(false);
        },
      });
      
      return (
        <>
          <Formik
              initialValues={{
                
                Inductee: props.Inductee || '',
              }}
              validationSchema={UploadSchema}
              onSubmit={(values:any) => {
                if(uploadedFiles.length > 0){
                  const data =  new FormData();
                  data.append('Inductee',uploadedFiles[0]);
                
                  addUpdate(data);
                }
                else{
                  set_notification({
                    type:'error',
                    message:'Select a file'
                  })
                  set_Nopen(true);
                  return;
                }
                
    
              }}
            >
              {(formik:any)=>{
            const {errors} = formik;
            return (
                <Form>
                  <Flex flexDir={"column"} align={"center"} gap="20px">             
                      {/* <Button leftIcon={<UpIcon/>}>Upload document</Button> */}
                    <Flex flexDir="column" gap="10px" w="100%">
                      
                        <Box>Upload Document:<br/></Box>             
                        <Box {...getRootProps()}>
                          <input {...getInputProps()} name="Inductee" id="file" />
                          <Image
                            alt="upload Applicant"
                            src={src}
                            w="100%"
                            h="150px"
                            objectFit="contain"
                            objectPosition="center"
                          />  
                          <UnorderedList sx={{p:'0',m:'0','listStyleType':'none'}}>
                          {uploadedFiles?.slice(0,1).map((file:any) => (
                            <ListItem align="center" gap="10px" as={Flex} sx={{p:'5p 0'}} fontSize="11px" key={file.name}><FileIcon />{file.name} <CancelIcon style={{marginLeft:'auto'}} onClick={()=>removeFile(file.name)} /></ListItem>
                          ))}
                        </UnorderedList>                   
                        </Box>
                    </Flex>
                    {/* <Field as={Input} multiple type='file' name="Document" /> */}
                    <Box>
                      {errors && Object.values(errors).map((eError:any,index:number)=> <Box color="red" key={index} >{eError}</Box>)}
                    </Box>
                    <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading} >
                        {isLoading?"Loading":'Submit'}
                    </Button>
                  </Flex>
                </Form>
              )}}
            </Formik>
        </>
      )
    }
    
    const DownloadSchema = Yup.object({
      templateType:Yup.string().required(),
    
    });
    const ViewDownloadTemplate = (props:any) =>{
      // console.log({...props},'data')
      
      const [,set_open] = useAtom(openAtom);
      const [,set_Nopen] = useAtom(openNAtom);
      const [,set_notification]= useAtom(notificationAtom);
      
      const {mutate:addUpdate,isLoading} = useMutation({
        mutationKey:[],
        mutationFn:async (templateType:string)=> {
          const headers = {
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          };
          return await apiCall().get(`/ExamUpload/download/${templateType}`,{
            headers,
            responseType:"blob"
    
          })},
        onSuccess:async(data:any)=>{
          //initial the download 
          //console.log(data,'download data')
          let file = data?.data;
          //console.log(file,'download file');
          if(file){
            const url = window.URL.createObjectURL(new Blob([file]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "template.xlsx");
            document.body.appendChild(link);
            link.click();
            //console.log(file,'data')
            set_notification({
              type:'success',
              message:data?.data?.Message || 'Application Template downloaded Successfully'
            })
            set_Nopen(true);
          }
          else{
            set_notification({
              type:'error',
              message:'Oooops! Error Occured trying to download file'
            })
            set_Nopen(true);
          }
          
          
          
        },
        onError(error:any, variables, context) {
          set_notification({
            type:'error',
            message:error?.data?.Message || 'Error Occured'
          })
          set_Nopen(true);
        },
        onSettled:()=>{
          set_open(false);
        }
    
      } )
      return (
        <>
          <Formik
              initialValues={{
                
                templateType: props.Inductee || '',
              }}
              validationSchema={DownloadSchema}
              onSubmit={(values:any) => {
                  if(values.templateType){
                    addUpdate(values.templateType);
                  }
    
              }}
            >
              {(formik:any)=>{
            const {errors} = formik;
            return (
                <Form>
                  <Flex flexDir={"column"} align={"center"} gap="20px">             
                      {/* <Button leftIcon={<UpIcon/>}>Upload document</Button> */}
                    <Flex flexDir="column" gap="10px" w="100%">
                      <Field as={Select} 
                        name="templateType"
                        placeholder="Select Template Type"
                      >
                        <option value="inductee">
                          Application
                        </option>
    
                      </Field>
                      <Box color="red">
                        {errors && errors.templateType? errors.tempateType:''}
                      </Box>
                        
                    </Flex>
                    {/* <Field as={Input} multiple type='file' name="Document" /> */}
                    
                    <Button type="submit" bg="var(--dark-green-color)" color="var(--white-color)" disabled={isLoading} >
                        {isLoading?"Loading":'Submit'}
                    </Button>
                  </Flex>
                </Form>
              )}}
            </Formik>
        </>
      )
    }
